import React, {useMemo, useState} from 'react';
import DropDown, {DropDownColor, DropDownOption, DropDownStyle} from '../../../shared/DropDown';

const baseCarrierBillingTypeOptions: DropDownOption[] = [
  {name: 'Sender', value: 'SENDER'},
  {name: 'Recipient', value: 'RECIPIENT'},
  {name: 'Third Party', value: 'THIRD_PARTY'},
  {name: 'Third Party Consignee', value: 'THIRD_PARTY_CONSIGNEE'},
  {name: 'Collect', value: 'COLLECT'}
];

const placeholder: DropDownOption = {
  name: 'Select a carrier billing type...',
  value: ''
};

interface CarrierBillingTypeDropdownProps {
  initialCarrierBillingType?: string;
  onCarrierBillingTypeChange: (type: string) => void;
}

const CarrierBillingTypeDropdown = ({
  initialCarrierBillingType,
  onCarrierBillingTypeChange
}: CarrierBillingTypeDropdownProps) => {
  const carrierBillingTypeDropdownOptions = useMemo(() => [placeholder, ...baseCarrierBillingTypeOptions], []);

  const [selectedCarrierBillingType, setSelectedCarrierBillingType] = useState<DropDownOption>(
    () =>
      carrierBillingTypeDropdownOptions.find((type) => type.value === initialCarrierBillingType?.toUpperCase()) ||
      placeholder
  );

  const updateCarrierBillingType = (option: DropDownOption) => {
    setSelectedCarrierBillingType(option);
    onCarrierBillingTypeChange(option.value as string);
  };
  return (
    <DropDown
      color={DropDownColor.white}
      options={carrierBillingTypeDropdownOptions}
      style={DropDownStyle.matchFont}
      selected={selectedCarrierBillingType}
      onSelect={updateCarrierBillingType}
    />
  );
};

export default CarrierBillingTypeDropdown;
